import React from "react";
import Gauge from "react-svg-gauge";
import UserInfoWrapper from "./heLevel.style";
import { Table } from "reactstrap";

const LatestActivity = ({data}) => {
  var heValues = (data ? (data.He_Status ? data.He_Status : '') : '').split(' ');

  heValues = heValues.filter(function (el) {
    return el !== "";
    
  });

  var He_Condition = ""

  if (data){
    if (data.He_Condition === "HE ALARM"){
      He_Condition = "dot-indicator bg-danger mt-1 mr-2";
    } else if (data.He_Condition === "HE WARN"){
      He_Condition = "dot-indicator bg-warning mt-1 mr-2";
    } else if (data.He_Condition === "OK") {
      He_Condition = "dot-indicator bg-success mt-1 mr-2";
    }
  }
    

  
  return (
    <UserInfoWrapper className="fill-height">
      <div className="card roe-shadow-2 fill-height">
        <div className="card-body">
          <h4 className="card-title fs-20">Helium Level</h4>
          <div className="row">
            <div className="col-md-6 aligner-wrapper text-center">
              <Gauge
                value={data ? (data.Level1 ? data.Level1.slice(0, -1): 0) : 0}
                width={200}
                height={140}
                label=""
                color="#17a2b8"
                valueLabelStyle={{ fontSize: "30px" }}
              />
              <h4>Level1</h4>
            </div>
            <div className="col-md-6 legend-wrapper">
              <div className="row">
      
                <div className="col-md-6 aligner-wrapper">
                  <div className="d-flex align-items-center">
                    <div className="dot-indicator bg-info mt-1 mr-2"></div>
                    <h5 className="mb-0 text-dark">{data ? (data.Level2 ? data.Level2 : "0%") : "0%"}</h5>
                  </div>
                  <small className="text-muted ml-3">Level2</small>
                </div>
                <div className="col-md-6 aligner-wrapper">
                  <div className="d-flex align-items-center">
                    <div className={He_Condition}></div>
                    <h5 className="mb-0 text-dark">{data ? (data.He_Condition ? data.He_Condition : " ") : " "}</h5>
                  </div>
                  <small className="text-muted ml-3">Status</small>
                </div>
              </div>
              
              <div className="d-flex flex-column justify-content-center border-top border-bottom py-3 mt-3 mb-3">
                <div className="d-flex align-items-center">
                  <Table bordered>
                    <thead>
                      <tr>
                        <th>0%</th>
                        <th>100%</th>
                        <th>ALRM%</th>
                        <th>WARN%</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{heValues[0]}</td>
                        <td>{heValues[1]}</td>
                        <td>{heValues[2] + " - " + heValues[3]}</td>
                        <td>{heValues[4] + " - " + heValues[5]}</td>
                      </tr>
                    </tbody>
                  </Table>
                  {/*<div className="dot-indicator bg-warning mt-1 mr-2"></div>
                  <h4 className="mb-0 text-dark">44%</h4>*/}
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </UserInfoWrapper>
  );
};

export default LatestActivity;
